// NPM Imports
import React, { Component } from "react";

// Components Imports
import TitleBar from "../../TitleBar";

class PipelineHeader extends Component {
  state = {};

  render() {
    return (
      <div className="pipelineheader-wrapper page-topbar">
        <TitleBar
          iconName="columns"
          title="OPPORTUNITY PIPELINE"
          subTitle="This is the kanban of your quotes."
        />
      </div>
    );
  }
}

export default PipelineHeader;



// WEBPACK FOOTER //
// ./src/components/PipelineWrapper/PipelineHeader/index.js